import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
function Stars({
  label
}: {
  label: string;
}) {
  return <span className="flex items-center gap-0.5" role="img" aria-label={label} data-id="element-159" data-mp="3kr5t64yb13k8">
      {Array.from({
      length: 5
    }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-160" data-mp="3b0uebnd319yk" data-mpi={index} />)}
    </span>;
}
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="w-full bg-ink" data-id="element-161" data-mp="36zqz932uzhye">
      <div className="mx-auto max-w-content px-5 py-10 sm:py-16 lg:py-24" data-id="element-162" data-mp="31zcze8bevebg">
        <div className="flex flex-wrap items-end justify-between gap-5" data-id="element-163" data-mp="2x0tg6fo7cgms">
          <h2 id="testimonios" className="max-w-xl font-display text-3xl text-cream sm:text-4xl" data-id="element-164" data-mp="2x2w2opq5brmr">
            Lo que dicen los terapeutas que ya usan el método
          </h2>
          <div className="flex items-center gap-3" data-id="element-165" data-mp="v85alzo35h3u">
            <Stars label="Calificación 4.9 de 5" data-id="element-166" data-mp="qalipwygt5tf" />
            <p className="text-[13px] text-muted" data-id="element-167" data-mp="qavb1r6zfp2a">
              <span className="font-semibold text-cream" data-id="element-168" data-mp="h67wpwq6ta6o">4.9/5</span> · Más de 500
              terapeutas capacitados
            </p>
          </div>
        </div>

        <ul className="mt-7 grid gap-4 sm:mt-12 sm:gap-5 lg:grid-cols-3" data-id="element-169" data-mp="m6cedq2u0ayh">
          {testimonials.map(item => <li key={item.name} className="flex h-full flex-col rounded-2xl border border-line bg-ink-raised p-7" data-id="element-170" data-mp="79v6x9xrjgh7">
              <Stars label="5 de 5 estrellas" data-id="element-171" data-mp="c8oigwthoxeq" />
              <blockquote className="mt-5 font-display text-xl leading-snug text-cream" data-id="element-172" data-mp="zxha4h32wj3j">
                “{item.quote}”
              </blockquote>
              <footer className="mt-auto pt-6 text-[13px] text-muted" data-id="element-173" data-mp="14xdckbw4o2gz">
                <span className="font-semibold text-cream" data-id="element-174" data-mp="q63c6dqrzrci">{item.name}</span> · {item.role}
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}